import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative w-full overflow-hidden bg-white px-4 py-8 md:py-20 lg:px-8" data-id="element-94">
      <div className="mx-auto max-w-7xl" data-id="element-95">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12 lg:items-center" data-id="element-96">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col space-y-6" data-id="element-97">
            <h1 className="font-serif text-4xl font-bold leading-tight text-terracotta md:text-5xl lg:text-6xl text-center lg:text-left" data-id="element-98">
              La cena finalmente es FÁCIL (y de calidad gourmet)
            </h1>

            <div className="space-y-6 text-center lg:text-left" data-id="element-99">
              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-100">
                Con el Protocolo de Cenas Tranquilas: Edición Escudo de
                Frescura, puedes preparar un mes de cenas entre semana en solo
                unas pocas horas y finalmente sentarte a disfrutar tu noche sin
                el estrés de "¿qué hay de cenar?".
              </p>

              {/* Product 4 Seasons Image */}
              <div className="mx-auto w-full lg:mx-0" data-id="element-101">
                <img src="https://cdn.magicpatterns.com/uploads/vo4UKLmoaSegBMWY4eDR4L/1.png" alt="Las 4 Guías de Temporada" className="w-full rounded-2xl shadow-xl" data-id="element-102" />
              </div>

              {/* Testimonial Image */}
              <div className="mx-auto w-full max-w-md lg:mx-0" data-id="element-103">
                <img src="https://cdn.magicpatterns.com/uploads/pRzUXFGu3fTcBnFewWkenA/testimonio.jpg" alt="Testimonio de María_C_OcupadaMamá" className="w-full rounded-lg shadow-md" data-id="element-104" />
              </div>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-105">
                Mi sistema ha sido usado por miles de familias para llevar
                comida de verdad a la mesa sin el agotamiento de planificar
                comidas a diario.
              </p>
            </div>

            <div className="flex flex-col items-center space-y-4 pt-4 lg:items-start" data-id="element-106">
              <div className="flex items-baseline space-x-3" data-id="element-107">
                <span className="text-2xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-108">
                  $37
                </span>
                <span className="text-4xl font-bold text-terracotta" data-id="element-109">
                  $9.98
                </span>
              </div>

              <a href="#mid-pricing" onClick={e => {
              e.preventDefault();
              document.getElementById('mid-pricing')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="group inline-flex items-center justify-center rounded-full bg-terracotta px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl hover:-translate-y-0.5" data-id="element-110">
                Compra el Protocolo de Cenas Tranquilas por $9.98
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-111" />
              </a>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-112">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl ring-4 ring-gray-100" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/5KgaRLHn7dGZKLwbNhwSa5/2.png" alt="El Paquete del Protocolo de Cenas Tranquilas" className="h-full w-full object-cover" data-id="element-114" />
            </div>
            {/* Decorative element - updated colors */}
            <div className="absolute -bottom-6 -right-6 -z-10 h-64 w-64 rounded-full bg-sage/10 blur-3xl" data-id="element-115"></div>
            <div className="absolute -top-6 -left-6 -z-10 h-64 w-64 rounded-full bg-terracotta/5 blur-3xl" data-id="element-116"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};